import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import { startCase } from 'lodash';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import { fetchPatientActivity } from '../../../services/api';

const PatientActivity = ({ patient, classes }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const events = await fetchPatientActivity(patient.id);
        setEvents(events);
      } catch (err) {
        console.error(err);
        enqueueSnackbar('Unable to fetch activity');
      } finally {
        setTimeout(() => setIsLoading(false), 400);
      }
    };
    if(patient.id){
      fetchData();
    }
    // fetchData();
  }, [patient.id, enqueueSnackbar]);

  if (isLoading) {
    return (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <Table className="tableWidth">
      <TableHead>
        <TableRow>
          <TableCell>What</TableCell>
          <TableCell>Who</TableCell>
          <TableCell>Appointment Time</TableCell>
          <TableCell>Created At</TableCell>
          <TableCell>Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {events.map(event => (
          <TableRow key={event.id}>
            <TableCell>{startCase(event.type)}</TableCell>
            <TableCell>{event.receivingProvider}</TableCell>
            <TableCell>
              {event.time ? Moment(event.time).format('YYYY-MM-DD h:mma') : ''}
            </TableCell>
            <TableCell>
              {Moment(event.createdAt).format('YYYY-MM-DD h:mma')}
            </TableCell>
            <TableCell>{startCase(event.status)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

PatientActivity.propTypes = {
  patient: PropTypes.object,
};

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

});
export default withStyles(styles)(PatientActivity);
// export default withSnackbar(withStyles(styles)(PatientActivity));
